import React, { useContext } from 'react';
import { AuthContext, LayoutContext } from 'contexts';
import { Divider, Empty, FroalaTaggedInput, Title } from 'components';

const useOrgName = () => {
  const {
    auth: { org, location, address },
  } = useContext(AuthContext);
  return org.addresses?.[location as any]?.[address as any]?.name ?? org.name;
};

const NotificationDetail: React.FC<{ body: string; notification: any }> = ({
  body,
  notification,
}) => {
  const orgName = useOrgName();

  const getHeaderType = (notificationDetail: any) => {
    if (!notificationDetail) return '';
    const { listing: { line1 = '', line2 = '' } = {} } = notificationDetail;
    switch (notificationDetail.type) {
      case 'adminBlast':
        return `Announcement - ${orgName}`;
      case 'appointmentTimeChange':
        return `Showing Update - ${notificationDetail.listing.org.name}`;
      case 'appointmentBooked':
      case 'appointmentDenied':
      case 'appointmentReminder':
      case 'appointmentConfirmed':
      case 'appointmentCancelled':
      case 'appointmentCoopReminder':
      case 'appointmentSellerTimeChange':
      case 'appointmentSellerTimeChangeRejected':
        return `Showings - ${notificationDetail.listing.org.name}`;
      case 'feedbackSubmitted':
        return `Listing Feedback - ${notificationDetail.listing.org.name}`;
      case 'offerRegisteredCoopAgents':
      case 'offerRegisteredCoopAgentsDelete':
        return `Offers Update - ${notificationDetail.listing.org.name}`;
      case 'offerRegisteredListingAgents':
      case 'offerRegisteredListingAgentsDelete':
        return 'Offer Updates';
      case 'propertyAnnouncement':
        return line1 ? `${line1} ${line2 || ''}` : 'Property Announcement';
      case 'propertyPriceChange':
        return line1 ? `Price Change - ${line1}` : 'Price Change';
      case 'propertyStatusChange':
        return line1 ? `Status Change - ${line1}}` : 'Status Change';
      case 'listingExpiryReminder':
        return `${notificationDetail.listing.org.name} Updates`;
      case 'transferAgentPending':
      case 'transferAgentAccepted':
      case 'transferAgentDenied':
      case 'transferAdminAccepted':
      case 'transferAdminDenied':
        return 'Transfer Request Service';
      case 'virtualTourConfirmed':
        return `Virtual Showings - ${notificationDetail.listing.org.name}`;
      default:
        return 'BrokerBay';
    }
  };

  return notification ? (
    <>
      <Title level={3}>From: {getHeaderType(notification)}</Title>
      <Title level={2}>{notification?.subject || ''}</Title>
      <Divider />
      <FroalaTaggedInput
        model={body}
        allowedIframeHostnames={[]}
        preview
        dataCy={`${notification?.id}`}
      />
    </>
  ) : (
    <Empty description={false} />
  );
};

export default NotificationDetail;
